import { AlertTriangle, Loader2 } from "lucide-react";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import type { BlockchainNetwork } from "@/interfaces/blockchainNetwork";

interface Props {
  open: boolean;

  loading?: boolean;

  network?: BlockchainNetwork | null;

  onClose: () => void;

  onDelete: (network: BlockchainNetwork) => Promise<void>;
}

const DeleteBlockchainNetworkDialog = ({
  open,
  loading,
  network,
  onClose,
  onDelete,
}: Props) => {
  if (!network) return null;

  return (
    <AlertDialog
      open={open}
      onOpenChange={(value) => {
        if (!value) onClose();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            Delete Blockchain Network
          </AlertDialogTitle>

          <AlertDialogDescription>
            You are about to permanently delete
            <span className="mx-1 font-semibold">{network.name}</span>
            from the platform.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <div className="rounded-xl border border-destructive/20 bg-destructive/5 p-4 text-sm">
          This action cannot be undone. Wallet addresses, assets and related
          records should already be migrated or removed before deleting this
          blockchain network.
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel disabled={loading}>Cancel</AlertDialogCancel>

          <AlertDialogAction
            disabled={loading}
            onClick={(e) => {
              e.preventDefault();

              onDelete(network);
            }}
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Deleting...
              </>
            ) : (
              "Delete Network"
            )}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default DeleteBlockchainNetworkDialog;
